var _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _path7, _path8, _path9, _circle3, _circle4, _circle5, _path10, _circle6, _circle7, _circle8, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuahua(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FED62E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.924476 1.83037C-0.975464 5.90458 2.25035 10.6046 4.10075 12.4454L8.53517 5.17805C6.63536 2.01932 2.66979 1.63013 0.924476 1.83037Z",
    fill: "#373636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12567 3.23238C1.29648 6.52274 3.486 9.93288 4.72991 11.215L7.73396 6.09356C6.45684 3.89337 3.29894 3.0929 2.12567 3.23238Z",
    fill: "#FFDF2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81552 4.24533C2.19717 6.69903 3.82995 9.24206 4.75756 10.1982L6.99776 6.37898C6.04538 4.73824 3.69045 4.14131 2.81552 4.24533Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8696 1.37254C19.4363 0.823121 16.5559 3.58518 15.5449 5.03489L19.9798 11.7014C24.3746 8.5885 23.7375 3.51844 22.8696 1.37254Z",
    fill: "#373636"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8461 2.93859C19.4612 2.55695 17.3058 4.91491 16.6035 5.92194L19.7223 10.185C22.7751 8.02265 22.449 4.42923 21.8461 2.93859Z",
    fill: "#FFDF2C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.288 3.76905C19.4528 3.47536 17.6884 5.17665 17.1479 5.95158L19.8448 10.0054C21.8091 7.9696 21.7519 4.91612 21.288 3.76905Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1549,
    cy: 12.4025,
    r: 8.16858,
    fill: "#373636"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0239 21.0703C12.4522 21.0833 12.1521 20.5346 12.0439 20.2585H14.1759C13.9432 20.5237 13.5956 21.0573 13.0239 21.0703Z",
    fill: "#F96453"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5181 13.4962V10.0343C11.5181 9.65395 11.7012 9.29681 12.01 9.07471C12.4085 8.78811 12.9426 8.77761 13.352 9.04832L13.3772 9.06498C13.7205 9.29194 13.927 9.67601 13.927 10.0875V13.4593C13.927 13.7056 14.0179 13.9431 14.1822 14.1266L15.9504 16.1004C16.3291 16.5231 16.5385 17.0706 16.5385 17.6381C16.5385 18.2769 16.2733 18.887 15.8064 19.3228L15.5831 19.5312C15.0262 20.0509 14.2929 20.34 13.5311 20.34H12.8136C11.9764 20.34 11.1657 20.0469 10.5222 19.5115L9.97419 19.0557C9.50299 18.6638 9.23047 18.0826 9.23047 17.4697C9.23047 17.0078 9.38543 16.5594 9.67054 16.1961L11.3048 14.1135C11.443 13.9374 11.5181 13.7201 11.5181 13.4962Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0986 18.0335C12.7183 18.0411 12.272 17.6623 11.9472 17.2721C11.7183 16.9972 11.9319 16.6433 12.2896 16.6433H13.8641C14.2269 16.6433 14.4431 17.0071 14.2104 17.2853C13.8948 17.6626 13.471 18.0261 13.0986 18.0335Z",
    fill: "#0E0E0E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.59155,
    cy: 13.3533,
    r: 3.10474,
    fill: "#FFED2D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.64575,
    cy: 13.4036,
    r: 2.34009,
    fill: "#373636"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.31396,
    cy: 12.1687,
    r: 0.916992,
    fill: "#FFFFF3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.624 15.5094C6.39038 15.3958 6.17849 15.2445 5.99626 15.0634C5.99583 15.055 5.99561 15.0465 5.99561 15.0379C5.99561 14.7667 6.21543 14.5469 6.48661 14.5469C6.75778 14.5469 6.97761 14.7667 6.97761 15.0379C6.97761 15.2614 6.82831 15.45 6.624 15.5094Z",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9216,
    cy: 13.3533,
    r: 3.10474,
    fill: "#FFED2D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9758,
    cy: 13.4036,
    r: 2.34009,
    fill: "#373636"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.644,
    cy: 12.1687,
    r: 0.916992,
    fill: "#FFFFF3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9541 15.5094C16.7205 15.3958 16.5086 15.2445 16.3263 15.0634C16.3259 15.055 16.3257 15.0465 16.3257 15.0379C16.3257 14.7667 16.5455 14.5469 16.8167 14.5469C17.0879 14.5469 17.3077 14.7667 17.3077 15.0379C17.3077 15.2614 17.1584 15.45 16.9541 15.5094Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuahua);
export default __webpack_public_path__ + "static/media/huahua.4788ed83fbfdd939a21a5b6f1774ab08.svg";
export { ForwardRef as ReactComponent };